import { createStore} from 'vuex'
import { initialState } from "./initialState";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";
import { createImagesModule } from "./modules/images";
import { createHyperlinksModule } from "./modules/hyperlinks";

export const store = createStore({
  state: { ...initialState },
  getters,
  mutations,
  actions,
  modules: {
    images: createImagesModule(),
    hyperlinks: createHyperlinksModule(),
  }
});
